import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';
import pdfIcon from 'assets/icons/pdf.svg';

import Box from '@material-ui/core/Box';
import MediaList from './MediaList';

const useStyles = makeStyles(({ theme }) => ({
    fileContainer: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: theme.spacing(2)
    },
    pdfIcon: {
        flex: '0 0 auto',
        width: '5em',
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            width: '3em'
        }
    },
    listContainer: {
        marginBottom: theme.spacing(2)
    }
}));

const AgreementList = ({ fields }) => {
    const classes = useStyles();
    return (
        <MediaList fields={fields} direction="vertical" className={classes.listContainer}>
            {
                () => (
                    <Box className={classes.fileContainer}>
                        <img src={pdfIcon} className={classes.pdfIcon} />
                    </Box>
                )
            }
        </MediaList>
    );
};

AgreementList.propTypes = {
    fields: PropTypes.object.isRequired
};

export default AgreementList;
